"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const ALLOWED_COMPONENT_NAMES = ["VideoPlayer", "LoyaltyVideoPreview"] as const;

const defaultVideoComponent = {
  "@type": "@builder.io/sdk:Element",
  component: {
    name: "VideoPlayer",
    options: {
      videoType: "hosted internally",
      hostedVideoConfiguration: {
        desktopSrc:
          "https://cdn.builder.io/o/assets%2F90293f7dc9704cb5935f357315020051%2Fdb83e0ca80d24c6da4c2fb863cd65ebb%2Fcompressed?apiKey=90293f7dc9704cb5935f357315020051&token=db83e0ca80d24c6da4c2fb863cd65ebb&alt=media&optimized=true",
      },
    },
  },
};

export const videoContainerInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Title",
  },
  {
    name: "childBlocks",
    type: "uiBlocks",
    onChange: (options: Map<string, unknown>) => {
      const childBlocks = options.get("childBlocks");

      if (!Array.isArray(childBlocks)) return;

      const allowedComponents = childBlocks.filter((block) => ALLOWED_COMPONENT_NAMES.includes(block.component?.name));

      if (allowedComponents.length !== childBlocks.length) {
        alert("Only VideoPlayer and LoyaltyVideoPreview components are allowed");
      }
    },

    defaultValue: Array(3).fill(defaultVideoComponent),
  },
] as const satisfies Inputs;

export const VideoContainerComponent: RegisteredComponent = {
  name: "VideoContainerComponent",
  friendlyName: "VideoContainerComponent",
  noWrap: true,
  component: dynamic(async () =>
    withValidation(videoContainerInputs, (await import("./VideoContainer")).VideoContainer, "VideoContainer")
  ),
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  canHaveChildren: true,
  childRequirements: {
    message: "Only VideoPlayer and LoyaltyVideoPreview components are allowed",
    query: {
      "component.name": {
        $in: ["VideoPlayer", "LoyaltyVideoPreview"],
      },
    },
  },
  inputs: videoContainerInputs,
};
